import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredLoadFileConfirmUploadAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadFileConfirmUpload',
  (params: { fileId: string }) => ({
    tradeFileConfirmUpload: {
      __args: { fileId: params.fileId },
      id: true,
      fileName: true,
      fileSize: true,
      mimeType: true,
      status: true,
    },
  }),
  { showLoadingOverlay: false },
);
